export const getSsoBaseUrl = (accessToken: string) => {
  return `${process.env.REACT_APP_WORDPRESS_BASE_URL}?rest_route=/simple-jwt-login/v1/autologin&JWT=${accessToken}&redirectUrl=${process.env.REACT_APP_WORDPRESS_BASE_URL}`;
};

export const productsCryptoAccounting = [
  {
    stage: "DEV",
    variants: [
      {
        productPlan: "basic",
        receiptPlan: "small",
        wcProductId: 177,
      },
      {
        productPlan: "balance-plus",
        receiptPlan: "small",
        wcProductId: 178,
      },
      {
        productPlan: "basic",
        receiptPlan: "medium",
        wcProductId: 179,
      },
      {
        productPlan: "balance-plus",
        receiptPlan: "medium",
        wcProductId: 180,
      },
      {
        productPlan: "basic",
        receiptPlan: "large",
        wcProductId: 181,
      },
      {
        productPlan: "balance-plus",
        receiptPlan: "large",
        wcProductId: 182,
      },
    ],
  },
  {
    stage: "PROD",
    variants: [
      {
        productPlan: "basic",
        receiptPlan: "small",
        wcProductId: 393,
      },
      {
        productPlan: "balance-plus",
        receiptPlan: "small",
        wcProductId: 394,
      },
      {
        productPlan: "basic",
        receiptPlan: "medium",
        wcProductId: 395,
      },
      {
        productPlan: "balance-plus",
        receiptPlan: "medium",
        wcProductId: 396,
      },
      {
        productPlan: "basic",
        receiptPlan: "large",
        wcProductId: 397,
      },
      {
        productPlan: "balance-plus",
        receiptPlan: "large",
        wcProductId: 398,
      },
    ],
  },
];
